import { Component, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SocialMedia from "./socialmedia";


const GameListTwo = () => {

    const [items, setItems] = useState([]);
    const [todayMatches, setTodayMatches] = useState([]);
    const [futureMatches, setFutureMatches] = useState([]);

    useEffect(() => {
        const someFunc = async () => {
            let array = [];
            const requestOptions = {
                method: "GET"
            };
            const response = await fetch(
                `http://localhost:3001/api/match/todayMatches`,
                requestOptions
            )
            const data = await response.json();
            setTodayMatches(data.matches);
        };
        someFunc();
        filterItem('match-one');



        const someFunc2 = async () => {
            let array = [];
            const requestOptions = {
                method: "GET"
            };
            const response = await fetch(
                `http://localhost:3001/api/match/futureMatches`,
                requestOptions
            )
            const data = await response.json();
            setFutureMatches(data.matches);
        };
        someFunc2();
    }, []);



    const filterItem = (section) => {

        if (section === "match-one") {
            setItems(todayMatches);
        } else {
            setItems(futureMatches);
        }
    }

    function handleSection(section) {
        let allArrays = todayMatches.concat(futureMatches);
        setItems(allArrays);
    }
    return (
        <section className="match-section padding-top padding-bottom">
            <div className="container">
                <div className="section-wrapper">
                    <ul className="match-filter-button-group common-filter-button-group d-flex flex-wrap justify-content-center mb-5 text-uppercase">
                        <li onClick={() => filterItem('match-one')}>Today's matches</li>
                        <li onClick={() => filterItem('match-two')}>Upcoming matches</li>
                        <li onClick={() => handleSection('today')}>All matches</li>
                    </ul>
                    <div className="row mb-5">
                        {items.map((val, i) => (
                            <div className="col-12" key={i}>
                                <div className="match-item-2 item-layer">
                                    <div className="match-inner">
                                        <div className="match-header d-flex flex-wrap justify-content-between align-items-center">
                                            <p className="match-team-info">{val.groupcount} <span className="fw-bold">{val.playercount}</span></p>
                                            <p className="match-prize">{val.matchpname} <span className="fw-bold">{val.matchpamount}</span></p>
                                        </div>
                                        <div className="match-content gradient-bg-yellow">
                                            <div className="row align-items-center justify-content-center">
                                                <div className="col-md-2 col-5 p-0">
                                                    <div className="match-team-thumb text-center">
                                                        <Link to="/team-single" className="text-center"><img src={val.imageone} alt={val.alt1} /></Link>
                                                    </div>
                                                </div>
                                                <div className="col-2 d-md-none">
                                                    <img src="assets/images/match/vs.png" alt="vs" />
                                                </div>
                                                <div className="col-md-2 col-5 order-md-3 p-0">
                                                    <div className="match-team-thumb text-center">
                                                        <Link to="/team-single"><img src={val.imagetwo} alt={val.alt2} /></Link>
                                                    </div>
                                                </div>
                                                <div className="col-md-8 order-md-2 mt-4 mt-md-0">
                                                    <div className="match-game-info text-center">
                                                        <h4><Link to="/team-single">{val.title}</Link>
                                                        </h4>
                                                        <p className="d-flex flex-wrap justify-content-center">
                                                            <span className="match-date" >{val.matchdate} </span>
                                                            <span className="match-time" >{val.matchtime}</span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-md-6 order-md-3">
                                                    <div className="match-game-social">
                                                        <ul className="match-social-list d-flex flex-wrap align-items-center justify-content-center justify-content-xl-start">
                                                           <li> 
                                                           <a href={`${val.link}`} className="default-button reverse-effect"><span>click here to watch now &nbsp;<i className="icofont-play-alt-1"></i></span></a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default GameListTwo;